import { createFileRoute, redirect } from '@tanstack/react-router';

import { UserRoles } from '~entities/users';
import { EmailCampaignsPage } from '~pages/email-campaigns';
import { checkMinRoleValue } from '~shared/utils/role-guard';

function RouteComponent() {
  return <EmailCampaignsPage />;
}

export const Route = createFileRoute('/_auth/_layout/email-campaigns')({
  beforeLoad: async () => {
    const hasAccess = await checkMinRoleValue(UserRoles.ADMIN);
    if (!hasAccess) {
      return redirect({
        to: '/dashboard',
      });
    }
  },
  component: RouteComponent,
});
